// src/api.js
import axios from 'axios';
import config from './config';

const api = axios.create({
  baseURL: config.API_BASE_URL,
});

// Helper: cerrar sesión y mandar al login
function forceLogout(reason = '') {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    if (reason === 'expired') {
      localStorage.setItem('sessionExpired', 'true'); // opcional: para mostrar aviso en Login
    }
  } finally {
    // Usar assign para recargar el estado global de la app
    window.location.assign('/');
  }
}

// Interceptor de request: agrega token y valida expiración
api.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // Decodificar payload del JWT (sin verificar firma) para leer exp
        const [, payloadB64] = token.split('.');
        const payload = JSON.parse(atob(payloadB64));
        const expMs = (payload.exp || 0) * 1000;

        // Margen de seguridad (clock skew) de 30s
        const nowMs = Date.now() + 30 * 1000;

        if (expMs && expMs <= nowMs) {
          console.warn('Token expirado (request).');
          forceLogout('expired');
          // Importante: cancelar esta request
          return Promise.reject(new axios.Cancel('Token expirado'));
        }

        request.headers.Authorization = `Bearer ${token}`;
      } catch (e) {
        console.error('Token inválido o malformado:', e);
        forceLogout();
        return Promise.reject(new axios.Cancel('Token inválido'));
      }
    }
    return request;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta: si el backend devuelve 401, forzar logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    const status = error?.response?.status;
    if (status === 401) {
      console.warn('401 recibido (response). Forzando logout.');
      forceLogout('expired');
    }
    return Promise.reject(error);
  }
);

export default api;
